
<div id="chart" >
  <apx-chart
    [lang]="'zh-tw'"
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [dataLabels]="chartOptions.dataLabels"
    [grid]="chartOptions.grid"
    [stroke]="chartOptions.stroke"
    [title]="chartOptions.title"
    [series]="chartOptions.series"
    (chartReady)="onChartReady($event)"
  ></apx-chart>
</div>
